import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

function ConfirmingReportItemPreviewModalTemplate({ confirmingReportItemPreviewModalViewStore }) {
    const {
        confirmingReportItems,
        salesOrderNumber
    } = confirmingReportItemPreviewModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Confirming Report Items, Sales Order Number: {salesOrderNumber}</h3>
            </div>
            <div className="modal__body">
                <div style={{ overflowX: "scroll" }}>
                    {confirmingReportItems &&
                    <table className="table--preview table--preview--confirming-report">
                        <thead>
                            <tr>
                                <th className="type--left">Item Id</th>
                                <th className="type--left">Item Name</th>
                                <th className="type--left">Sales Order Number</th>
                                <th className="type--left">Insurance Info</th>
                                <th className="type--left">POS</th>
                                <th className="type--left">Branch Office</th>
                                <th className="type--left">Reference</th>
                                <th className="type--left">DWO/TOF</th>
                                <th className="type--left">Sales Order Note</th>
                                <th className="type--left">Height</th>
                                <th className="type--left">Weight</th>
                                <th className="type--left">Confirming Status</th>
                                <th className="type--left">Delivery Scheduled Date</th>
                                <th className="type--left">Doctor Full Name</th>
                                <th className="type--left">Dx Code #01</th>
                                <th className="type--left">Dx Code #02</th>
                                <th className="type--left">Dx Code #03</th>
                                <th className="type--left">Dx Code #04</th>
                                <th className="type--left">Dx Code #05</th>
                                <th className="type--left">Dx Code #06</th>
                                <th className="type--left">Dx Code #07</th>
                                <th className="type--left">Dx Code #08</th>
                                <th className="type--left">Primary Insurance Id</th>
                                <th className="type--left">Primary Insurance</th>
                                <th className="type--left">Primary Policy Verified</th>
                                <th className="type--left">Secondary Policy Verified</th>
                                <th className="type--left">Item Id</th>
                                <th className="type--left">Item Name</th>
                                <th className="type--left">ML/CAL Amount</th>
                                <th className="type--left">QTY</th>
                                <th className="type--left">BQTY</th>
                                <th className="type--left">Days Supply</th>
                                <th className="type--left">DOS To Date</th>
                                <th className="type--left">Procedure Code</th>
                                <th className="type--left">Item Category</th>
                                <th className="type--left">Transmit this CMN?</th>
                                <th className="type--left">Date Transmitted</th>
                                <th className="type--left">Initial Date</th>
                                <th className="type--left">Revised Date</th>
                                <th className="type--left">Doctors Name</th>
                                <th className="type--left">Doctor Signed Date</th>
                                <th className="type--left">Est Length of Need</th>
                                <th className="type--left">CMN Dx Code #01</th>
                                <th className="type--left">CMN Dx Code #02</th>
                                <th className="type--left">CMN Dx Code #03</th>
                                <th className="type--left">CMN Dx Code #04</th>
                                <th className="type--left">Q1</th>
                                <th className="type--left">Q2</th>
                                <th className="type--left">Q3A</th>
                                <th className="type--left">Q3B</th>
                                <th className="type--left">Q4A</th>
                                <th className="type--left">Q4B</th>
                                <th className="type--left">Q5</th>
                                <th className="type--left">Q6</th>
                                <th className="type--left">Q7</th>
                                <th className="type--left">Q8 8 Amino Acid (ml/day)</th>
                                <th className="type--left">Q8 Amino Acid concentration%</th>
                                <th className="type--left">Q8 Amino Acid gms (protein/day)</th>
                                <th className="type--left">Q8 Dextrose (ml/day)</th>
                                <th className="type--left">Q8 Dextrose concentration%</th>
                                <th className="type--left">Q8 Lipids (ml/day)</th>
                                <th className="type--left">Q8 Lipids concentration%</th>
                                <th className="type--left">Q8 Lipids (days/week)</th>
                                <th className="type--left">Q9</th>
                                <th className="type--left">Generic Q - Prognosis of Patient</th>
                                <th className="type--left">Name of Person Answering the Questions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {confirmingReportItems.map((item) => {
                                return ( <tr key={item.id}>
                                    <td>{item.itemId}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.salesOrderNumber}</td>
                                    <td>{item.insuranceInfo}</td>
                                    <td>{item.pos}</td>
                                    <td>{item.branchOffice}</td>
                                    <td>{item.reference}</td>
                                    <td>{item.dwoTof}</td>
                                    <td>{item.salesOrderNote}</td>
                                    <td>{item.height}</td>
                                    <td>{item.weight}</td>
                                    <td>{item.confirmingStatus}</td>
                                    <td>{item.deliveryScheduledDate}</td>
                                    <td>{item.doctorFullName}</td>
                                    <td>{item.dxCode1}</td>
                                    <td>{item.dxCode2}</td>
                                    <td>{item.dxCode3}</td>
                                    <td>{item.dxCode4}</td>
                                    <td>{item.dxCode5}</td>
                                    <td>{item.dxCode6}</td>
                                    <td>{item.dxCode7}</td>
                                    <td>{item.dxCode8}</td>
                                    <td>{item.primaryInsuranceRemoteId}</td>
                                    <td>{item.primaryInsurance}</td>
                                    <td>{item.primaryPolicyVerified !==  null ? item.primaryPolicyVerified.toString().toUpperCase() : "" }</td>
                                    <td>{item.secondaryPolicyVerified !== null ? item.secondaryPolicyVerified.toString().toUpperCase() : "" }</td>
                                    <td>{item.itemId}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.mlCalAmount}</td>
                                    <td>{item.qty}</td>
                                    <td>{item.bqty}</td>
                                    <td>{item.daysSupply}</td>
                                    <td>{item.dosToDate}</td>
                                    <td>{item.procedureCode}</td>
                                    <td>{item.itemCategory}</td>
                                    <td>{item.transmitThisCmn !== null ? item.transmitThisCmn.toString().toUpperCase() : "" }</td>
                                    <td>{item.dateTransmitted}</td>
                                    <td>{item.initialDate}</td>
                                    <td>{item.revisedDate}</td>
                                    <td>{item.doctorsName}</td>
                                    <td>{item.doctorSignedDate}</td>
                                    <td>{item.estLengthOfNeed}</td>
                                    <td>{item.cmnDxCode1}</td>
                                    <td>{item.cmnDxCode2}</td>
                                    <td>{item.cmnDxCode3}</td>
                                    <td>{item.cmnDxCode4}</td>
                                    <td>{item.q1}</td>
                                    <td>{item.q2}</td>
                                    <td>{item.q3A}</td>
                                    <td>{item.q3B}</td>
                                    <td>{item.q4A}</td>
                                    <td>{item.q4B}</td>
                                    <td>{item.q5}</td>
                                    <td>{item.q6}</td>
                                    <td>{item.q7}</td>
                                    <td>{item.q88AminoAcidMlPerDay}</td>
                                    <td>{item.q8AminoAcidConcentrationPercentage}</td>
                                    <td>{item.q8AminoAcidGmsProteinPerDay}</td>
                                    <td>{item.q8DextroseMlPerDay}</td>
                                    <td>{item.q8DextroseConcentrationPercentage}</td>
                                    <td>{item.q8LipidsMlPerDay}</td>
                                    <td>{item.q8LipidsConcentrationPercentage}</td>
                                    <td>{item.q8LipidsDaysPerWeek}</td>
                                    <td>{item.q9}</td>
                                    <td>{item.genericQPrognosisOfPatient}</td>
                                    <td>{item.nameOfPersonAnsweringTheQuestions}</td>
                                </tr>)
                            }

                            )}
                            
                        </tbody>
                    </table>
                }
                </div>
            </div>
        </section>
    )
}

ConfirmingReportItemPreviewModalTemplate.propTypes = {
    confirmingReportItemPreviewModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ConfirmingReportItemPreviewModalTemplate);
